module.exports = __webpack_public_path__ + "static/media/ta-logo.b13b2f24.svg";